const mytest = () => {
  console.log('Hello world!')
}

export default mytest
